import React from 'react'
import PropTypes from 'prop-types'
import {Box, Image} from '@chakra-ui/react'
import {pxToRem} from '../../utills/pxToRem'

const CloudinaryImageSwatches = ({
    cloudinaryImageGallery = {},
    value,
    onChange,
    swatchStyles = {},
    showFallbackImage = false
}) => {
    if (!cloudinaryImageGallery.cldSwatches) return null

    const handleImageLoad = (event) => {
        const img = event?.target
        if (img) {
            img.onload = null
            img.hidden = false
        }
    }

    const handleImageError = (event) => {
        const fallbackUrl = cloudinaryImageGallery?.cartImage?.url
        const img = event?.target
        if (fallbackUrl && img && img?.src !== fallbackUrl) {
            img.onerror = null // Prevent infinite loop
            img.src = fallbackUrl
        }
        if (img) {
            img.hidden = false
        }
    }
    return (
        <>
            {cloudinaryImageGallery.cldSwatches.map((cldSwatch, idx) => {
                const {variationAttrValueID, cldUrl} = cldSwatch
                const isSelected = value === variationAttrValueID

                return (
                    <Box
                        as="button"
                        key={variationAttrValueID || idx}
                        onClick={() => onChange && onChange(variationAttrValueID)}
                        border={
                            isSelected
                                ? `${pxToRem(1)} solid black`
                                : `${pxToRem(1)} solid transparent`
                        }
                        borderRadius="full"
                        p={
                            isSelected
                                ? swatchStyles.padding ?? [
                                      pxToRem(2.5),
                                      pxToRem(2.5),
                                      pxToRem(4),
                                      pxToRem(4)
                                  ]
                                : pxToRem(1)
                        }
                        bg="transparent"
                        cursor="pointer"
                        width={
                            swatchStyles.width ?? [
                                pxToRem(25),
                                pxToRem(25),
                                pxToRem(40),
                                pxToRem(40)
                            ]
                        }
                        height={
                            swatchStyles.height ?? [
                                pxToRem(25),
                                pxToRem(25),
                                pxToRem(40),
                                pxToRem(40)
                            ]
                        }
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        transition="border 0.2s, padding 0.2s"
                    >
                        <Image
                            height="100%"
                            borderRadius="full"
                            src={cldUrl}
                            alt={variationAttrValueID}
                            onLoad={showFallbackImage ? handleImageLoad : null}
                            hidden={showFallbackImage}
                            onError={showFallbackImage ? handleImageError : null}
                        />
                    </Box>
                )
            })}
        </>
    )
}

CloudinaryImageSwatches.propTypes = {
    cloudinaryImageGallery: PropTypes.object,
    value: PropTypes.string,
    onChange: PropTypes.func,
    swatchStyles: PropTypes.any,
    showFallbackImage: PropTypes.bool
}

export default CloudinaryImageSwatches
